var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["card-indicator", _vm.type] }, [
    _vm.type === "type-3"
      ? _c(
          "div",
          { staticClass: "card-indicator--header" },
          [
            _c(
              "el-tag",
              {
                attrs: {
                  size: "small",
                  type: _vm.typeIconBox,
                  plain: "",
                  circle: ""
                }
              },
              [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e()]
            ),
            _vm._v(" "),
            _c("h6", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "card-indicator--header" },
          [
            _c("h6", { staticClass: "mb-0 text-black-50" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c(
              "el-tag",
              {
                staticClass: "rounded-circle",
                style: {
                  minWidth: "20px",
                  minHeight: "20px"
                },
                attrs: {
                  size: _vm.type == "type-min" ? "mini" : "small",
                  type: _vm.typeIconBox,
                  plain: ""
                }
              },
              [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e()]
            )
          ],
          1
        ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-indicator--description" },
      [_vm._t("description")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-indicator--footer" },
      [
        _c("h5", { staticClass: "mb-0" }, [
          _c("strong", [_vm._v(_vm._s(_vm.value))])
        ]),
        _vm._v(" "),
        _vm._t("extra")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e3b95a3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3b95a3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Card/CardIndicator.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3e3b95a3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Card/CardIndicator.vue
// module chunks = 2